module.exports = __webpack_public_path__ + "img/2024-08-29b_1.53bb7da0.jpg";